module.exports = __webpack_public_path__ + "img/5.3ca9f86e.png";